import { useMutation } from "react-query";

import type { SwitchTreatmentProgramArgs } from "api/schemas/patients/SwitchTreatmentPrograms";
import { useApiClient } from "api/useApiClient";

export const usePostPatientSwitchTreatmentProgram = () => {
  const client = useApiClient();
  return useMutation<null, Error, SwitchTreatmentProgramArgs>(args => client.postPatientSwitchTreatmentProgram(args));
};
